import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

interface Props {
  label: string;
}

export const MonthlyContribution = ({ label }: Props) => {
  const formBag = useFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.MonthlyContribution"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          label={label}
          innerText="/month"
          leftIcon="far fa-dollar-sign"
          decimalScale={2}
          allowNegative={false}
        />
      )}
    />
  );
};
